import React from 'react';
import { cn } from '@/lib/utils';
import './PriceRibbon.css';

export interface PriceRibbonProps extends React.HTMLAttributes<HTMLSpanElement> {
  label: string;
  loading?: boolean;
  offsetTop?: string;
  offsetRight?: string;
}

type PriceRibbonStyle = React.CSSProperties & {
  '--price-ribbon-offset-top'?: string;
  '--price-ribbon-offset-right'?: string;
};

export const PriceRibbon = React.forwardRef<HTMLSpanElement, PriceRibbonProps>((props, ref) => {
  const { label, loading = false, className, offsetTop, offsetRight, style, ...rest } = props;

  const ribbonStyle: PriceRibbonStyle = {
    ...(style as React.CSSProperties),
    ...(offsetTop ? { '--price-ribbon-offset-top': offsetTop } : {}),
    ...(offsetRight ? { '--price-ribbon-offset-right': offsetRight } : {}),
  };

  return (
    <span
      ref={ref}
      className={cn('price-ribbon', loading && 'price-ribbon--loading', className)}
      style={ribbonStyle}
      aria-label={label}
      {...rest}
    >
      {loading ? <span className="price-ribbon__loading-dots" aria-hidden>...</span> : label}
    </span>
  );
});

PriceRibbon.displayName = 'PriceRibbon';
